import React from 'react';
import Icon from '../shared/Icon';
import { FilterSelect, ViewToggle } from '../Library/LibraryToolbar';
import { ASSESSMENT_STATUS, ASSESSMENT_STATUS_ORDER } from '../../../models/AssessmentsModel';

const VISIBILITY_OPTIONS = [
  ['active', 'Active'],
  ['archived', 'Archived'],
  ['all', 'All'],
];
const STATUS_OPTIONS = [['all', 'All statuses'], ...ASSESSMENT_STATUS_ORDER.map((s) => [s, ASSESSMENT_STATUS[s].label])];
const SORT_OPTIONS = [
  ['date_desc', 'Newest first'],
  ['date_asc', 'Oldest first'],
  ['name_asc', 'Name A–Z'],
  ['name_desc', 'Name Z–A'],
  ['dur_asc', 'Shortest duration'],
  ['dur_desc', 'Longest duration'],
];

/**
 * Search, then scenario, status and visibility filters, the sort (grid only:
 * in the list the headers sort) and the view toggle (PRD-1703), on the
 * Library's toolbar. The status filter and the sort are ordered scales, so
 * they keep their order; the scenario filter is alphabetical.
 */
function AssessmentsToolbar({ filters, view, scenarios, onFilterChange, onViewChange, searchRef }) {
  const scenarioOptions = [['all', 'All scenarios'], ...scenarios.map((s) => [s.id, s.name])];
  return (
    <div className="library-toolbar">
      <div className="library-toolbar-left">
        <div className="library-search">
          <Icon name="magnifying-glass" size={14} className="library-search-icon" />
          <input
            ref={searchRef}
            type="text"
            className="resui-input library-search-input"
            placeholder="Search assessments…"
            aria-label="Search assessments"
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
          />
        </div>
        <FilterSelect label="Filter by scenario" value={filters.scenario} options={scenarioOptions} onChange={(v) => onFilterChange('scenario', v)} />
        <FilterSelect label="Filter by status" value={filters.status} options={STATUS_OPTIONS} onChange={(v) => onFilterChange('status', v)} scale />
        <FilterSelect label="Filter by visibility" value={filters.visibility} options={VISIBILITY_OPTIONS} onChange={(v) => onFilterChange('visibility', v)} />
        {view === 'grid' && (
          <FilterSelect label="Sort assessments" value={filters.sort} options={SORT_OPTIONS} onChange={(v) => onFilterChange('sort', v)} scale />
        )}
      </div>
      <ViewToggle view={view} onViewChange={onViewChange} />
    </div>
  );
}

export default AssessmentsToolbar;
